/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-line no-unused-vars
const AUTHED_WEBVIEW_URL_NAMES = {
  BACKGROUND_INFORMATION: 'BACKGROUND_INFORMATION',
  CONTACT_INFO: 'CONTACT_INFO',
  MFA_ENROLLMENT: 'MFA_ENROLLMENT',
  PRIMARY_CARE: 'PRIMARY_CARE',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  COMMUNICATION_PREFERENCES: 'COMMUNICATION_PREFERENCES',
};

const SSO_URL_NAMES = {
  SAPPHIRE: 'sapphire',
  KYRUUS: 'kyruus',
};

const defaultConfig = {
  HIGHMARK_API_URL: 'https://api-qa.highmark.com',
  AMH_CDN_URL: 'https://test.cdn.allmyhealth.com',
  HIGHMARK_CDN_URL: 'https://test.cdn.highmark.com',
  useCurrentRegionUbkHeader: () => null,
  LinkHandler: {
    handleLink: (_val: any) => {},
  },
  getAuthedWebviewUrl: (_val: any) => {},
  getSsoUrl: (_val: any) => {},
  AUTHED_WEBVIEW_URL_NAMES,
  SSO_URL_NAMES,
};

let accountManagementConfig = defaultConfig;

export const accountManagementLibrary = {
  config(config: any) {
    if (!config)
      throw new Error('Account Management: You must provide a config');

    accountManagementConfig = { ...defaultConfig, ...config };
  },

  getConfig() {
    if (!accountManagementConfig)
      throw new Error('Account Management: Configuration is not defined.');
    return accountManagementConfig;
  },
};
